import { jsx as _jsx } from "react/jsx-runtime";
import { Button, getContrastRatio, Grid, } from '@mui/material';
const ColorChip = ({ label, value, columns = 2, color, rounded = '', handleSelect, }) => (_jsx(Grid, { item: true, xs: columns, children: _jsx(Button, { size: "small", sx: {
            width: 1,
            padding: 0,
            minWidth: 0,
            borderColor: '#aaa',
            borderStyle: 'solid',
            borderTopWidth: ['a', 't', 'tl', 'tr'].includes(rounded) ? 1 : 0,
            borderRightWidth: ['a', 'r', 'tr', 'br'].includes(rounded) ? 1 : 0,
            borderBottomWidth: ['a', 'b', 'bl', 'br'].includes(rounded) ? 1 : 0,
            borderLeftWidth: ['a', 'l', 'tl', 'bl'].includes(rounded) ? 1 : 0,
            borderTopLeftRadius: ['a', 'tl', 'l'].includes(rounded) ? 4 : 0,
            borderTopRightRadius: ['a', 'tr', 'r'].includes(rounded) ? 4 : 0,
            borderBottomLeftRadius: ['a', 'bl', 'l'].includes(rounded) ? 4 : 0,
            borderBottomRightRadius: ['a', 'br', 'r'].includes(rounded) ? 4 : 0,
            backgroundColor: color,
            color: getContrastRatio(color || '#000', '#fff') > 4.5 ? '#fff' : '#111',
            '&:hover': {
                background: color,
                color: getContrastRatio(color || '#000', '#fff') > 4.5 ? '#ccc' : '#444',
            },
        }, onClick: () => handleSelect(value), children: label }) }));
ColorChip.defaultProps = {
    rounded: '',
    columns: 2,
};
export default ColorChip;
//# sourceMappingURL=ColorChip.js.map